export const CLEAR_PIVOT_PEST_DISEASE = "CLEAR_PIVOT_PEST_DISEASE";
export const READ_ONE_PIVOT_PEST_DISEASE = "READ_ONE_PIVOT_PEST_DISEASE";
export const SET_PIVOT_PEST_DISEASE_DATA = "SET_PIVOT_PEST_DISEASE_DATA";
export const READ_PIVOT_PEST_DISEASES = "READ_PIVOT_PEST_DISEASES";
export const START_PIVOT_PEST_DISEASES_RELOAD =
  "START_PIVOT_PEST_DISEASES_RELOAD";
export const FINISHED_PIVOT_PEST_DISEASES_RELOAD =
  "FINISHED_PIVOT_PEST_DISEASES_RELOAD";
export const PIVOT_PEST_DISEASE_ERROR = "PIVOT_PEST_DISEASE_ERROR";
